import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=40ed1e36&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ed1e36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40ed1e36')) {
      api.createRecord('40ed1e36', component.options)
    } else {
      api.reload('40ed1e36', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=40ed1e36&scoped=true&", function () {
      api.rerender('40ed1e36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-22eYVouS6rb90/JS/comp/Voucher-Unit.vue"
export default component.exports